export const paceStatusAlert = {
    paceStatusNormal:1,
    paceStatusWarning:2,
    paceStatusCritical:3,
}

export const batteryStatusAlert = {
    warningBatteryLevel: 25,
    criticalBatteryLevel : 10,
}